import React from 'react'
import '../orgChart.scss'
import PersonCard from './PersonCard'

const PersonnelGrid = ({ personnel, onPersonClick }) => {
  return (
    <div className="org-chart-personnel-grid">
      {personnel.map((person) => (
        <PersonCard
          key={person.id}
          person={person}
          onClick={() => onPersonClick(person)}
        />
      ))}
    </div>
  )
}

export default PersonnelGrid
